<template>
  <div>
    <div class="row">
      <div class="col-sm-1">1.1</div>
      <div class="col-sm-11">
        {{fss.agency_letters_patent}}
      </div>
    </div>
    <div class="row">
      <div class="col-sm-1">1.2</div>
      <div class="col-sm-11">
        <template v-if="fss.unit_number">{{fss.unit_number}}-</template>
        {{fss.street_number}} {{fss.street_name}} <br />
        <template v-if="fss.po_box">CP {{fss.po_box}}<br /></template>
        {{fss.city}} {{fss.prov}} {{fss.postal_code}}
      </div>
    </div>
  </div>
</template>

<script>

// Ce fichier est encore en développement, et non utilisé

// import OnValidationFssDetail from '@/components/OnValidationFssDetail.vue'
import axios from 'axios';

export default {
  data: function() {return {
    fss: {},
  }},

  name: 'OnValidationFss',
  components: {
    // OnValidationFssDetail,
  },
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/validation_one_hsp.php',
          { params: {agency_id: this.$route.params.agency_id}})
        .then(response => {
          this.fss = response.data.fss;
        })
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>
